const INVESTMENT_ENDPOINTS = {
    VIEW_INVESTMENT_REPORT: "frontend/get-investment-report",
    VIEW_INVESTMENT_INPUTS: "frontend/get-investment-report-inputs"
}


export default INVESTMENT_ENDPOINTS